import { Link } from "react-router-dom";
import ArticleCard from "@/components/feature/ArticleCard";
import { getLatestArticles } from "@/mocks/articles";

export default function TrendingSidebar() {
  const latestArticles = getLatestArticles(6);

  return (
    <aside className="w-full lg:w-[340px] flex-shrink-0">
      <div className="sticky top-24">
        <div className="bg-background-100 rounded-lg p-5 mb-5">
          <h3 className="text-base font-bold text-foreground-950 font-heading mb-4 flex items-center gap-2">
            <i className="ri-bar-chart-line text-accent-500 w-5 h-5 flex items-center justify-center"></i>
            24小时热榜
          </h3>
          <div className="space-y-0">
            {latestArticles.slice(0, 5).map((article, index) => (
              <Link
                key={article.id}
                to={`/article/${article.id}`}
                className="flex items-start gap-3 py-3 border-b border-background-200 last:border-0 group cursor-pointer"
              >
                <span className={`flex-shrink-0 w-6 h-6 flex items-center justify-center rounded-full text-xs font-bold ${
                  index < 3 ? "bg-primary-500 text-background-50" : "bg-background-200 text-foreground-500"
                }`}>
                  {index + 1}
                </span>
                <div className="flex-1 min-w-0">
                  <p className="text-sm text-foreground-800 line-clamp-2 group-hover:text-primary-500 transition-colors leading-snug">
                    {article.title}
                  </p>
                  <span className="text-xs text-foreground-400 mt-1 inline-block">
                    {article.viewCount > 10000 ? `${(article.viewCount / 10000).toFixed(1)}万阅` : `${article.viewCount}阅`}
                  </span>
                </div>
              </Link>
            ))}
          </div>
        </div>

        <div className="bg-background-100 rounded-lg p-5">
          <h3 className="text-base font-bold text-foreground-950 font-heading mb-4 flex items-center gap-2">
            <i className="ri-timer-line text-primary-500 w-5 h-5 flex items-center justify-center"></i>
            最新爆料
          </h3>
          <div className="space-y-0">
            {latestArticles.map((article) => (
              <ArticleCard key={article.id} article={article} variant="compact" />
            ))}
          </div>
        </div>
      </div>
    </aside>
  );
}